module.exports = __webpack_public_path__ + "img/margen.d32dee71.png";